import { useMIPManageContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/MIPManageContext';
import { CreateCustomFieldDrawer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/InvestorData/components/CreateCustomFIle/CreateCustomFieldDrawer.tsx';
import { CustomFieldsTable } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/InvestorData/components/CustomFieldsTable/CustomFieldsTable.tsx';
import { useInvestorData } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/InvestorData/useInvestorData.ts';
import { InvestorDataRequirementsList } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/InvestorData/components/InvestorDataRequirementsList';
import { KycSection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/styles.ts';
import { ENTITY_TABS } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/types.ts';
import { MantineTabs } from '@dealstack/frontend/shared/components/MantineTabs/MantineTabs.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { DataCustomDetailTct } from '@dealstack/shared/lib/generated';
import { Button, Flex, Text } from '@mantine/core';
import { useState } from 'react';
import { MantineTabProps } from '@dealstack/frontend/shared/components/MantineTabs/MantineTab.types';

export const InvestorData = () => {
	const tMipManage = useTranslationMipManage();
	const mipManageController = useMIPManageContext();
	const mipId = mipManageController.mipId;
	const [activeTab, setActiveTab] = useState<ENTITY_TABS>(ENTITY_TABS.INDIVIDUAL);
	const [drawerOpened, setDrawerOpened] = useState(false);
	const [editingField, setEditingField] = useState<DataCustomDetailTct | null>(null);
	const investorData = useInvestorData({ mipId });

	const tabsConfig: MantineTabProps<ENTITY_TABS>[] = [
		{
			label: tMipManage('kyc_settings.label.individual'),
			value: ENTITY_TABS.INDIVIDUAL,
			icon: 'information',
		},
		{
			label: tMipManage('kyc_settings.label.vehicle'),
			value: ENTITY_TABS.INVESTMENT_VEHICLE,
			icon: 'derived_commuted_structure',
		},
	];

	const handleEditField = (field: DataCustomDetailTct) => {
		setEditingField(field);
		setDrawerOpened(true);
	};

	const handleAddField = () => {
		setEditingField(null);
		setDrawerOpened(true);
	};

	const handleCloseDrawer = () => {
		setDrawerOpened(false);
		setEditingField(null);
	};

	return (
		<div style={{ width: '100%' }}>
			<MantineTabs
				tabs={tabsConfig}
				panels={[]}
				onlyDividerBorder={true}
				value={activeTab}
				onTabChange={(value) => setActiveTab(value as ENTITY_TABS)}
			>
				<KycSection>
					<InvestorDataRequirementsList
						type={activeTab}
						individualSettings={investorData.individualSettings}
						vehicleSettings={investorData.vehicleSettings}
						toggleIndividualSetting={investorData.toggleIndividualSetting}
						toggleVehicleSetting={investorData.toggleVehicleSetting}
						hasPermission={investorData.hasPermission}
					/>

					<Flex justify="space-between" gap="1rem" mt="sm">
						<Text fw={600}>
							{tMipManage('investor_data.custom_fields.section_title')}
						</Text>

						<Button onClick={handleAddField} variant="default">
							{tMipManage('investor_data.custom_fields.add_button')}
						</Button>
					</Flex>

					<CustomFieldsTable
						fields={
							(activeTab === ENTITY_TABS.INDIVIDUAL
								? investorData.individualCustomDetails
								: investorData.vehicleCustomDetails) || []
						}
						isLoading={false}
						hasPermission={investorData.hasPermission}
						onEdit={handleEditField}
						onToggleChecked={investorData.toggleCustomFieldChecked}
					/>
				</KycSection>
			</MantineTabs>
			<CreateCustomFieldDrawer
				opened={drawerOpened}
				onClose={handleCloseDrawer}
				activeTab={activeTab}
				editField={editingField}
				mipId={mipId}
			/>
		</div>
	);
};
